module.exports = "/_next/static/images/video_id_7106684955370999086-0cd545dc4a8c77c9533921d30dab9c57.jpg";